import { render, staticRenderFns } from "./ConfirmAuthPage.vue?vue&type=template&id=8a19c852"
import script from "./ConfirmAuthPage.vue?vue&type=script&lang=js"
export * from "./ConfirmAuthPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports